const PasswordManagerFilters = {
  activeUsers: isActive => (
    {
      name: 'active',
      operator: 'eq',
      value: isActive,
    }),

  appVersion: version => (
    {
      name: 'appVersion',
      operator: 'eq',
      value: version,
    }),

  groupUsers: groupId => (
    {
      name: 'GroupId',
      operator: 'eq',
      value: groupId,
    }),

  itemType: itemType => (
    {
      name: 'type',
      operator: 'eq',
      value: itemType,
    }),

  itemTypes: itemTypes => (
    {
      name: 'type',
      operator: 'in',
      value: itemTypes.join('|'),
    }),

  oldPasswords: count => (
    {
      name: 'oldPasswords',
      operator: 'gt',
      value: count,
    }),

  operatingSystem: os => (
    {
      name: 'OperatingSystemId',
      operator: 'eq',
      value: os,
    }),

  operatingSystems: operatingSystems => (
    {
      name: 'OperatingSystemId',
      operator: 'in',
      value: operatingSystems.join('|'),
    }),

  sharedFolder: folderId => (
    {
      name: 'folderUuid',
      operator: 'eq',
      value: folderId,
    }),

  sharedFolders: folderIds => (
    {
      name: 'folderUuid',
      operator: 'in',
      value: folderIds.join('|'),
    }),

  weakPasswords: count => (
    {
      name: 'weakPasswords',
      operator: 'gt',
      value: count,
    }),
};

export default PasswordManagerFilters;
